import formMultiple from "./formMultiple.vue";

export default formMultiple;
